import React from "react";
import { useNavigate } from "react-router-dom";
import { Logo } from "@/lib/ui";
import { useAuth } from "@/context/Auth";
import ProfileForm from "@/components/ProfileForm";

export default function SellerOnboard() {
  const nav = useNavigate();
  const { user, refresh } = useAuth();

  return (
    <div className="min-h-screen bg-slate-50">
      <header className="border-b border-slate-200 bg-white px-6 py-4"><Logo /></header>
      <div className="mx-auto max-w-3xl px-4 py-8">
        <h1 className="font-head text-3xl font-extrabold text-slate-900">Complete your company profile</h1>
        <p className="mt-1 text-sm text-slate-500">
          Registered as a <b className="capitalize">{user?.seller_type}</b>. This information helps buyers trust and connect with you.
        </p>
        <div className="mt-6 rounded-2xl border border-slate-200 bg-white p-6">
          <ProfileForm
            initial={{ whatsapp: user?.phone }}
            submitLabel="Save & Enter Dashboard"
            onSaved={async () => { await refresh(); nav("/seller/app"); }}
          />
        </div>
      </div>
    </div>
  );
}
